import tunnel from 'tunnel-rat';

export const three = tunnel();
export const hud = tunnel();
export const ui = tunnel();
